import { render, staticRenderFns } from "./LpuCardsActiveFilterChip.vue?vue&type=template&id=13dc4394&scoped=true&"
import script from "./LpuCardsActiveFilterChip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardsActiveFilterChip.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuCardsActiveFilterChip.vue?vue&type=style&index=0&id=13dc4394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dc4394",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13dc4394')) {
      api.createRecord('13dc4394', component.options)
    } else {
      api.reload('13dc4394', component.options)
    }
    module.hot.accept("./LpuCardsActiveFilterChip.vue?vue&type=template&id=13dc4394&scoped=true&", function () {
      api.rerender('13dc4394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsActiveFilterChip.vue"
export default component.exports